import useAuth from '@/hooks/useAuth'
import React from 'react'
import ForgotModal from './Auth/ForgotModal'
import LoginModal from './Auth/LoginModal'
import RegisterModal from './Auth/RegisterModal'
import DesktopHeader from './DesktopHeader'
import MobileHeader from './MobileHeader'
import NotificationPanel from './NotificationPanel'

interface Props {
  featured_categories: any
  settings: any
  categories: any
}
export default function Header({
  featured_categories,
  settings,
  categories,
}: Props) {
  const [isLoginOpen, setIsLoginOpen] = React.useState(false)
  const [isForgotOpen, setIsForgotOpen] = React.useState(false)
  const [isRegisterOpen, setIsRegisterOpen] = React.useState(false)
  const [lastOpened, setLastOpened] = React.useState<'register' | 'login'>(
    'login',
  )
  const [loginMethod, setLoginMethod] = React.useState<
    'email' | 'phone' | undefined
  >(undefined)
  return (
    <>
      <NotificationPanel/>
      <header className="bg-white sticky top-0 z-[100] shadow-lg md:static lg:static">
        <div className="header container-fluid py-2 mx-auto">
          {/*
           * Mobile Header
           */}
          <MobileHeader
            setIsLoginOpen={setIsLoginOpen}
            setIsForgotOpen={setIsForgotOpen}
            setIsRegisterOpen={setIsRegisterOpen}
            setLastOpened={setLastOpened}
            headerCategories={categories}
            lastOpened={'login'}
          />
          <DesktopHeader
            featured_categories={featured_categories}
            setIsLoginOpen={setIsLoginOpen}
            setIsRegisterOpen={setIsRegisterOpen}
            setIsForgotOpen={setIsForgotOpen}
            setLastOpened={setLastOpened}
            lastOpened={lastOpened}
          />

          <LoginModal
            isOpen={isLoginOpen}
            setIsLoginOpen={setIsLoginOpen}
            setIsForgotOpen={setIsForgotOpen}
            setIsRegisterOpen={setIsRegisterOpen}
            setLastOpened={setLastOpened}
          />

          <RegisterModal
            isOpen={isRegisterOpen}
            setIsLoginOpen={setIsLoginOpen}
            setLoginMethod={setLoginMethod}
            loginMethod={loginMethod}
            setIsRegisterOpen={setIsRegisterOpen}
            setIsOpen={setIsRegisterOpen}
            setLastOpened={setLastOpened}
            lastOpened={lastOpened}
          />
          <ForgotModal isOpen={isForgotOpen} setIsOpen={setIsForgotOpen} />
        </div>
      </header>
    </>
  )
}
